@import '../../styles/host.css';

:host {
    display: inline-block;
}

:host([full-width]) {
    display: flex;
}

:host([disabled]) button {
    cursor: not-allowed;
    opacity: var(--protean-button-disabled-opacity, 0.4);
}

button {
    color: inherit;
    cursor: pointer;
    width: 100%;
    height: var(--protean-button-height, 42px);
    transition:
        background-color 0.2s ease-in-out,
        color 0.2s ease-in-out,
        border 0.2s ease-in-out;
}

button > div {
    display: flex;
    align-items: center;
    justify-content: center;
}

:host([variant]) button {
    border-radius: var(--protean-button-border-radius, 2px);
}

:host([variant='primary']) button,
:host([variant='secondary']) button {
    padding: 0 1.25rem;
    border: 2px solid;
    font-weight: 600;
}

:host([variant='primary']) button {
    background-color: var(--protean-button-primary-background-color, #6e45e4);
    color: var(--protean-button-primary-text-color, #ffffff);
    border-color: var(--protean-button-primary-border-color, transparent);
}

:host([variant='secondary']) button {
    background-color: var(
        --protean-button-secondary-background-color,
        transparent
    );
    color: var(--protean-button-secondary-text-color, inherit);
    border-color: var(--protean-button-secondary-border-color, #6e45e4);
}

:host(:not([disabled])[variant='primary']) button:hover,
:host(:not([disabled])[variant='primary']) button:focus {
    background-color: var(
        --protean-button-primary-hover-background-color,
        #c7b5fb
    );
    color: var(--protean-button-primary-hover-text-color, #000000);
    border-color: var(--protean-button-primary-hover-border-color, transparent);
}

:host(:not([disabled])[variant='secondary']) button:hover,
:host(:not([disabled])[variant='secondary']) button:focus {
    background-color: var(
        --protean-button-secondary-hover-background-color,
        #c7b5fb
    );
    color: var(--protean-button-secondary-hover-text-color, #000000);
    border-color: var(
        --protean-button-secondary-hover-border-color,
        transparent
    );
}

:host([variant='icon']) button {
    width: var(--protean-button-icon-size, 42px);
    background-color: var(--protean-button-icon-background-color);
    --protean-icon-stroke-primary: var(--protean-button-icon-stroke-color);
}

:host(:not([disabled])[variant='icon']) button:hover,
:host(:not([disabled])[variant='icon']) button:focus {
    background-color: var(--protean-button-icon-hover-background-color);
    --protean-icon-hover-stroke-primary: var(
        --protean-button-icon-hover-stroke-color
    );
}
